import { Box } from "@mui/material";
import MaskMultiSelectScroll from "../../../MaskMultiSelectScroll";
import {
  MaskMultiSelectScrollProps,
  MData,
} from "../../../mask-multi-select/types";
import { CHART_DIMENSIONS } from "../patient/chart/tokens";

interface FilterMaskMultiSelectScrollProps<
  T extends MData,
> extends MaskMultiSelectScrollProps<T> {
  width?: string;
}

/**
 * Infinite-scroll variant of {@link FilterMaskMultiSelect}: same header-filter
 * height, but backed by {@link MaskMultiSelectScroll} so options load on scroll.
 */
const FilterMaskMultiSelectScroll = <T extends MData>({
  width = "13rem",
  ...props
}: FilterMaskMultiSelectScrollProps<T>) => (
  <Box
    width={width}
    sx={{
      "& .MuiOutlinedInput-root": {
        height: CHART_DIMENSIONS.controlHeight,
        minHeight: CHART_DIMENSIONS.controlHeight,
        padding: "0 8px !important",
        display: "flex",
        alignItems: "center",
      },
      "& .MuiOutlinedInput-input": {
        height: "100% !important",
        padding: "0 !important",
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
      },
      "& .MuiInputBase-root": {
        height: CHART_DIMENSIONS.controlHeight,
      },
      "& .MuiFormControl-root": {
        height: CHART_DIMENSIONS.controlHeight,
      },
    }}
  >
    <MaskMultiSelectScroll {...props} />
  </Box>
);

export default FilterMaskMultiSelectScroll;
